import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { HomeTryOn } from "../../../blocks/home-try-on";

import { ReplaceAuth0 } from "./ReplaceAuth0";
import { SolutionTable } from "./SolutionTable";
import { SolutionTransfer } from "./SolutionTransfer";
import Helmet from "react-helmet";
import { SolutionProduct } from "../../../components/SolutionProduct";
import { SolutionBanner } from "../../../blocks/solution-banner-new";
import { useTranslation } from "react-i18next";

export const Auth0Page = () => {
  const { t } = useTranslation();
  const banner = {
    title: t("solution.auth0.banner.title"),
    subtitle: t("solution.auth0.banner.description"),
    background: "solution-auth0-banner.png",
    link: "https://www.authing.cn/authingform?fromTag=Auth0方案咨询",
    download:
      "/authingform?fromTag=Auth0&download=https://host.huiju.cool/file/6680150219df4a278ac8eacd64c49111",
  };
  return (
    <div className="auth0-page">
      <Helmet>
        <title>中国替代Auth0的身份认证与访问管理解决方案-Authing身份云</title>
      </Helmet>
      <Header mode="dark" hasNotice />
      <SolutionBanner {...banner} rcodeUrl="solution-auth0-1.png" />
      <ReplaceAuth0 />
      {/* <SolutionSceneTable data={data} /> */}
      <SolutionTable />
      <SolutionTransfer />
      <SolutionProduct />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
